import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function PublicLayout({ children }) {
  return (
    <div className="min-h-screen bg-marketing">
      <Navbar />
      <main>{children}</main>
      <Footer />
    </div>
  );
}
